module.exports = __webpack_public_path__ + "media/images/dark_blue-4596f1f4881c6cae7f8b920bc864da6c.png";